/**
 * Pressure card grid entrance — fade + rotate + rise (scroll-timed, play-once).
 * Desktop grid only (`PRESSURE_CARD_HOVER_MEDIA` / md+). See docs/04-motion.md.
 */

import { durations } from '@/motion/tokens';

export const pressureCardEntrance = {
  /**
   * Fire when the cards wrap top reaches this fraction of the viewport from
   * the top (0.45 ≈ 45vh). Same trigger on all desktop breakpoints so tall
   * md/lg grids are not gated on unreachable visible-area fractions.
   */
  topAt: 0.45,
  /** Start offset below rest (px). */
  y: 64,
  /** Clockwise start tilt (degrees). */
  rotateDeg: 28,
  /** Per-card transition duration (seconds). */
  duration: durations.slow + 0.05,
  /** Delay between successive cards in DOM order (seconds). */
  staggerSeconds: 0.08,
  /** Bottom-center pivot so cards swing up into place. */
  transformOrigin: '50% 100%',
} as const;

export type PressureCardEntranceConfig = typeof pressureCardEntrance;
